/* eslint-disable react-hooks/exhaustive-deps */
//import packages
import React, { useState, useEffect } from "react";
import { Row, Col, Input, Form, Spin, message, Modal, Button, Radio, Tooltip } from "antd";
import styled from "styled-components";
import {
  StopOutlined,
  ExclamationCircleOutlined,
  ArrowDownOutlined,
  FileTextOutlined,
  ArrowUpOutlined,
  EditOutlined,
  LoadingOutlined,
  CalendarOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";

//import components
import PhysicianFilter from "./PhysicianFilter";
import {
  StyledComponentWrapper,
  StyledTable,
  SearchFilterWrapper,
  TableRow,
} from "../../components/PhysicianComponent/AllPhysicianComponent";
import {
  ActionButtonGroup,
  TableHeader as SharedTableHeader,
  Title,
  TitleControls,
} from "../SharedStyles";
import CopyString from "../../components/CopyString";
import UserRolesAndRightsHOComponent from "../../components/UserRolesAndRightsHOComponent/UserRolesAndRightsHOComponent";

//import other files and API function
import { getPhysicians, updatePhysicianDetails } from "../../api/PhysiciansAPI";
import authorization from "../../auth/authorization";

const { Search } = Input;
const { confirm } = Modal;

const TableHeader = styled(SharedTableHeader)`
  align-items: flex-start;
`;

const ALL_PHYSICIANS_CURRENT_PAGE = "ALL_PHYSICIANS_CURRENT_PAGE";
const ALL_PHYSICIANS_PAGE_SIZE = "ALL_PHYSICIANS_PAGE_SIZE";

const AllPhysicians = ({
  clients,
  states,
  telemedicineCategory,
  tags,
  onItemClick,
  onEditPhysicianClick,
  onAddPhysicianClick,
  userType,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [activePhysiciansFilter, setActivePhysiciansFilter] = useState(true)
  const [physicians, setPhysicians] = useState([]);
  const [physicianFilters, setFilters] = useState({
    client: "",
    telemedicineCategory: "",
    state: "",
    fetchType: "all",
    tags: []
  });
  const [tablePageSize, setTablePageSize] = useState(localStorage.getItem(ALL_PHYSICIANS_PAGE_SIZE) || 100);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchValue] = useState("");
  const [columns, setColumns] = useState([
    {
      title: "Full name",
      width: 100,
      dataIndex: "fullName",
      key: "fullName",
      fixed: "left",
    },
    {
      title: "Credential",
      dataIndex: "credential",
      width: 120,
      key: "credential",
    },
    {
      title: "Id",
      dataIndex: "",
      width: 100,
      key: "id",
      render: (physician) => (
        <CopyString text={physician._id} abbreviationLength={5} />
      ),
    },
    {
      title: "Employment Status",
      dataIndex: "employmentStatus",
      width: 200,
      key: "employment-status",
    },
  ]);

  const onPageSizeChange = (current, size) => {
    onChangePage(1, size);
    setTablePageSize(size);
    setCurrentPage(1);
    window.localStorage.setItem(ALL_PHYSICIANS_PAGE_SIZE, size);
  };

  const onChangePage = (value, pageSize) => {
    setCurrentPage(value);
    window.localStorage.setItem(ALL_PHYSICIANS_CURRENT_PAGE, value);
  };

  const updateColumnsInListing = () => {
    const clonnedColumns = columns.slice(0);
    clonnedColumns.push({
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      width: 300,
      align: "center",
      fixed: "right",
      render: (_, record) => (
        <ActionButtonGroup>
          {authorization.isAllowed(userType, "getCases") ? (
            <Tooltip title="View queue">
              <Button
                shape="circle"
                icon={<UnorderedListOutlined />}
                onClick={(event) => {
                  event.stopPropagation();
                  onViewQueueClick(event, record);
                }}
              />
            </Tooltip>
          ) : null}
          {authorization.isAllowed(userType, "getPhysicianDetailsForAdmin") ? (
            <Tooltip title="View details">
              <Button
                shape="circle"
                icon={<FileTextOutlined />}
                onClick={(event) => {
                  event.stopPropagation();
                  onTableRowClick(event, record);
                }}
              />
            </Tooltip>
          ) : null}
          <Tooltip title="Edit">
            <Button
              shape="circle"
              icon={<EditOutlined />}
              onClick={(event) => {
                event.stopPropagation();
                onEditPhysicianClick(event, record);
              }}
            />
          </Tooltip>
          {authorization.isAllowed(userType, "physicianModerationByAdmin") && record.status === "active" ? (
            <Tooltip title="Archive">
              <Button
                shape="circle"
                icon={<ArrowDownOutlined />}
                onClick={(event) => {
                  event.stopPropagation();
                  showArchiveConfirmation(record, { status: "archive" });
                }}
              />
            </Tooltip>
          ) : null}
          {authorization.isAllowed(userType, "physicianModerationByAdmin") && record.status === "archive" ? (
            <Tooltip title="Activate">
              <Button
                shape="circle"
                icon={<ArrowUpOutlined />}
                onClick={(event) => {
                  event.stopPropagation();
                  showArchiveConfirmation(record, { status: "activate" });
                }}
              />
            </Tooltip>
          ) : null}
          {authorization.isAllowed(userType, "physicianModerationByAdmin") ? (
            <Tooltip title="Deactivate">
              <Button
                shape="circle"
                icon={<StopOutlined />}
                onClick={(event) => {
                  event.stopPropagation();
                  showDeleteConfirmation(record, { status: "delete" });
                }}
              />
            </Tooltip>
          ) : null}
          {authorization.isAllowed(userType, "provider.impersonation:read:many") ? (
            <Tooltip title="Impersonate">
              <Button
                shape="circle"
                onClick={(event) => {
                  event.stopPropagation();
                  history.push(`/providers/${record._id}/impersonate`);
                }}
                icon={<UserOutlined />}
              />
            </Tooltip>
          ) : null}
        </ActionButtonGroup>
      ),
    });

    setColumns([...clonnedColumns]);
  };

  const initCallsForComponent = () => {
    updateColumnsInListing();
  };

  const transformPhysicianData = (data) => {
    return data.map(physician => ({
      ...physician,
      key: physician._id,
      fullName: `${physician.firstName} ${physician.lastName}`
    }));
  }

  const fetchProviders = () => {
    setLoading(true);
    getPhysicians({ 
      fetchType: physicianFilters.fetchType,
      client: physicianFilters.client,
      teleMedicineCategory: physicianFilters.telemedicineCategory,
      state: physicianFilters.state,
      tags: physicianFilters.tags,
      active: activePhysiciansFilter,
      searchTerm
    })
      .then((res) => {
        if (res.data && res.data.payload) {
          const physicianData = transformPhysicianData(res.data.payload);
          setPhysicians(physicianData);
        } else {
          message.error("Unable to load Provider List");
        }
        setLoading(false);
      })
      .catch((error) => {
        message.error("Unable to load Provider List");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchProviders();
  }, [physicianFilters, searchTerm, activePhysiciansFilter]);

  useEffect(initCallsForComponent, [userType]);

  const onFilterChange = (filterValues) => {
    setFilters(filterValues);
  };

  const onTableRowClick = (event, record) => {
    onItemClick(event, record);
  };

  const handleSearchValueChange = (searchTerm) => {
    setSearchValue(searchTerm);
  };

  const handleSearchInputChange = (searchEvent) => {
    if (searchEvent.target.value === "" || searchEvent.target.value === null) {
      setSearchValue(searchEvent.target.value);
    }
  };

  const onViewQueueClick = (e, physician) => {
    history.push(`/physician-case-queue/${physician._id}?physician-name=${physician.firstName}%20${physician.lastName}`);
  }

  const updatePhysician = (physicianId, statusDetails) => {
    updatePhysicianDetails(physicianId, statusDetails)
      .then((res) => {
        if (res.status === 204) {
          if (statusDetails.status === "delete") {
            message.success("Successfully Deactivated Provider");
          }

          if (statusDetails.status === "archive") {
            message.success("Successfully Archived Provider");
          }

          if (statusDetails.status === "active") {
            message.success("Successfully Activated Provider");
          }
        } else {
          const { data } = res;
          if (data && data.success) {
            if (statusDetails.status === "delete") {
              message.success("Successfully Deactivated Provider");
            }

            if (statusDetails.status === "archive") {
              message.success("Successfully Archived Provider");
            }

            if (statusDetails.status === "active") {
              message.success("Successfully Activated Provider");
            }
          } else {
            if (data && data.message) {
              message.error(data.message);
            } else {
              message.error("Unable to update provider status");
            }
          }
        }
        fetchProviders();
      })
      .catch((error) => {
        console.log(
          "================== provider status update error ========================",
          error
        );
        const { response } = error;
        if (response) {
          const { data } = response;
          if (data && data.message) {
            message.error(data.message);
          } else {
            message.error("Error occurred while updating provider status");
          }
        } else {
          message.error("Error occurred while updating provider status");
        }
      });
  };

  const showDeleteConfirmation = (physician, status) => {
    confirm({
      title: `Do you want to deactivate ${physician.firstName}  ${physician.lastName}?`,
      icon: <ExclamationCircleOutlined />,
      content:
        "Any cases currently assigned to this provider will be unassigned, except those that are complete, archived, or cancelled.",
      okType: "danger",
      okText: "Deactivate and unassign",
      onOk: () => {
        updatePhysician(physician._id, status);
      },
      onCancel() {},
    });
  };

  const showArchiveConfirmation = (physician, statusInfo) => {
    const isArchive = statusInfo.status !== "activate";
    confirm({
      title: isArchive
        ? `Do you want to archive ${physician.firstName}  ${physician.lastName}?`
        : `Do you want to activate ${physician.firstName}  ${physician.lastName}?`,
      icon: <ExclamationCircleOutlined />,
      content: isArchive
        ? "Any cases currently assigned to this provider will be unassigned, except those that are complete, archived, or cancelled."
        : undefined,
      onOk: () => {
        updatePhysician(physician._id, statusInfo);
      },
      onCancel() {},
    });
  };

  return (
    <StyledComponentWrapper>
      <Spin spinning={loading} size="large" indicator={<LoadingOutlined />}>
        <TableHeader>
          <Title level={2}>All Providers
            <TitleControls>
              <Radio.Group value={activePhysiciansFilter} size="small" onChange={e => setActivePhysiciansFilter(e.target.value)}>
                <Radio.Button value={true}>Active</Radio.Button>
                <Radio.Button value={false}>Inactive</Radio.Button>
              </Radio.Group>
            </TitleControls>
          </Title>
          {authorization.isAllowed(userType, "registerPhysician") ? (
            <Button type="primary" size="large" onClick={onAddPhysicianClick}>
              Add
            </Button>
          ) : null}
        </TableHeader>
        <Row>
          <Col span={24}>
            <Form name="search-form" layout={"vertical"}>
              <Form.Item rules={[{}]}>
                <SearchFilterWrapper>
                  <Search
                    size={"large"}
                    placeholder={"Search by Name or Email"}
                    onChange={handleSearchInputChange}
                    onSearch={handleSearchValueChange}
                  />
                  <PhysicianFilter
                    clients={clients}
                    states={states}
                    telemedicineCategory={telemedicineCategory}
                    tags={tags}
                    onFilter={onFilterChange}
                  />
                </SearchFilterWrapper>
              </Form.Item>
            </Form>
          </Col>
        </Row>
        <TableRow>
          <Col span={24}>
            <StyledTable
              columns={columns}
              dataSource={physicians}
              pagination={{
                current: currentPage,
                pageSize: tablePageSize,
                pageSizeOptions: ["5", "10", "20", "50", "100"],
                showSizeChanger: true,
                onChange: onChangePage,
                onShowSizeChange: onPageSizeChange,
              }}
              scroll={{ x: 720, y: "calc(100vh - 380px)" }}
            />
          </Col>
        </TableRow>
      </Spin>
    </StyledComponentWrapper>
  );
};

export default UserRolesAndRightsHOComponent(AllPhysicians);
